/**
 * Tenant Detail — data hooks for PR 3 tabs.
 * Each hook returns { data, loading, error, reload }.
 */
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = (typeof window !== "undefined" && window.location
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL) + "/api";

const authHeader = () => {
  const t = localStorage.getItem("token") || localStorage.getItem("access_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

function useEndpoint(url) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(url, { headers: authHeader() });
      setData(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [url]);
  useEffect(() => { reload(); }, [reload]);
  return { data, loading, error, reload };
}

export const useTenantOverview = (id) => useEndpoint(`${API}/super-admin/tenants/${id}/overview`);
export const useTenantContacts = (id) => useEndpoint(`${API}/super-admin/tenants/${id}/contacts`);
export const useTenantPlan     = (id) => useEndpoint(`${API}/super-admin/tenants/${id}/plan-details`);
export const useTenantUsage    = (id) => useEndpoint(`${API}/super-admin/tenants/${id}/usage-details`);

export async function saveTenantContacts(id, payload) {
  const res = await axios.put(
    `${API}/super-admin/tenants/${id}/contacts`,
    payload,
    { headers: authHeader() },
  );
  return res.data;
}
